'use client'

import { cn } from '@/utils/shadcn/utils'

import { Progress as BaseProgressBar } from './base'

export interface ProgressBarProps {
  className?: string
  value?: number
  completedColor?: string
  remainingColor?: string
}

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default function ProgressBar({
  className,
  value = 0,
  completedColor,
  remainingColor,
  ...props
}: ProgressBarProps) {
  return (
    <BaseProgressBar
      className={cn(className)}
      value={value}
      completedColor={completedColor}
      remainingColor={remainingColor}
      {...props}
    />
  )
}
